
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWindTrue3 as ObiWindTrue3Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-wind-true-3.js';
 
 
 

 
 export const ObiWindTrue3 = createComponent({
   react: React,
   tagName: 'obi-wind-true-3',
   elementClass: ObiWindTrue3Element,
   events: {
     
   }
  });
 
 